import React from "react";

const MissionIcon = ({
  className = "",
  viewBox = "0 0 36 36",
  fill = "currentColor",
  stroke = "currentColor",
  strokeWidth = "2",
  ...props
}) => (
  <svg
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M18 3L4.5 9.75V16.5C4.5 24.15 9.435 31.245 18 33C26.565 31.245 31.5 24.15 31.5 16.5V9.75L18 3ZM18 6.285L28.5 11.745V16.5C28.5 22.71 24.66 28.545 18 30.015C11.34 28.545 7.5 22.71 7.5 16.5V11.745L18 6.285ZM16.5 15V25.5H19.5V15H16.5ZM16.5 10.5V13.5H19.5V10.5H16.5Z"
      fill={fill}
    />
  </svg>
);

export default MissionIcon;
